import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: "root",
})
export class SchedulesService {
  constructor(private http: HttpService) {}

  createSchedule(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/createSchedule", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  getAllByService(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/getAllByService", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  searchUsersByService(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/searchUsersByService", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  changeSchedules(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/changeSchedules", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  deleteSchedule(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/deleteSchedule", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  manageAvailability(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/manageAvailability", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  requestScheduleChange(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/requestScheduleChange", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  getAllByUser(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/getAllByUser", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }
  getAllByHospital(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/getAllByHospital", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  getAllByParticipation(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/getAllByUser", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  takeOverSchedule(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/takeOverSchedule", true, data)
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }

  getScheduleHospital(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          "api/schedules/schedulesV2/getScheduleByInstitution/?entity" +
            data.instituicao,
          true,
          data
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => console.log(err));
    });
  }
  manageAvailabilityChangedSchedule(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          "api/schedules/schedulesV2/manageAvailabilityChangedSchedule",
          true,
          data
        )
        .then((res) => {
          resolve(res);
        });
    }).catch((err) => console.log("Error trying to create schedule: ", err));
  }
  callMedical(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/callMedical/", true, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => console.log(err));
    });
  }
  callJustification(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/callJustification/", true, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => console.log(err));
    });
  }
  closedSchedule(data: any) {
    return new Promise((resolve, reject) => {
      this.http
        .post("api/schedules/schedulesV2/closedSchedule", true, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => console.log(err));
    });
  }
}
